import * as React from 'react';
import {
  List,
  DatagridConfigurable,
  TextField,
  EditButton,
  NumberInput,
  SelectColumnsButton,
  TopToolbar,
  FilterButton,
  CreateButton,
  DateInput, DateField,
  useLocaleState, NumberField
} from "react-admin";

const FaqListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const faqFilters = [
    <NumberInput key={0} source="id" label="id" min={1} />,
    <NumberInput key={0} source="position" label="position" />,
    <DateInput key={6} source="createdAt#$gte" label="Start Created At" />,
    <DateInput key={7} source="createdAt#$lte" label="End Created At" />,
];

export const FaqList = () => {
  const [locale] = useLocaleState();

  return (
    <List
      filters={faqFilters}
      sort={{ field: 'position', order: 'ASC' }}
      actions={<FaqListActions />}
    >
      <DatagridConfigurable rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />

        <TextField source={`question.${locale}`} />
        <TextField source={`answer.${locale}`} />
        <NumberField name={'position'} source={'position'} />

        <DateField source="createdAt" showTime locales="lv-LV" />
        <EditButton />
      </DatagridConfigurable>
    </List>
  )
};
